// Organization Member Model
cv.OrganizationMember = Backbone.RESTModel.extend({
  defaults : {
  },

  saveMap : {
  },

  urlRoot: function(){
    return cv.api_path + '/organizations/' + this.collection.params.organization_id + '/members';
  },

  initialize: function(){
    console.log('Organization member model initialized.');
  }
});
Cocktail.mixin(cv.OrganizationMember, cv.mixins.SyncModel);

// Organization Members Collection
cv.OrganizationMembers = Backbone.Collection.extend({
  initialize: function(){
    console.log('Organization members collection initialized.');
  },

  url: function() {
    return cv.api_path + "/organizations/" + this.params.organization_id + "/members";
  },

  model: cv.OrganizationMember
});
Cocktail.mixin(cv.OrganizationMembers, cv.mixins.PaginateModel);
